// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file analytics.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file analytics.proto.
 */
export const file_analytics: GenFile = /*@__PURE__*/
  fileDesc("Cg9hbmFseXRpY3MucHJvdG8SCXJhY2Nvb25haSKmAQoUU2VydmljZVByb3ZpZGVyU3RhdHMSKgoQaWRsZV90cnVja19jb3VudBgBIAEoBVIQaWRsZV90cnVja19jb3VudBIyChR1bmFzc2lnbmVkX2pvYl9jb3VudBgCIAEoBVIUdW5hc3NpZ25lZF9qb2JfY291bnQSLgoSYWN0aXZlX3JvdXRlX2NvdW50GAMgASgFUhJhY3RpdmVfcm91dGVfY291bnRCBloELi9wYg");

/**
 * @generated from message raccoonai.ServiceProviderStats
 */
export type ServiceProviderStats = Message<"raccoonai.ServiceProviderStats"> & {
  /**
   * @generated from field: optional int32 idle_truck_count = 1 [json_name = "idle_truck_count"];
   */
  idleTruckCount: number;

  /**
   * @generated from field: optional int32 unassigned_job_count = 2 [json_name = "unassigned_job_count"];
   */
  unassignedJobCount: number;

  /**
   * @generated from field: optional int32 active_route_count = 3 [json_name = "active_route_count"];
   */
  activeRouteCount: number;
};

/**
 * @generated from message raccoonai.ServiceProviderStats
 */
export type ServiceProviderStatsJson = {
  /**
   * @generated from field: optional int32 idle_truck_count = 1 [json_name = "idle_truck_count"];
   */
  idle_truck_count?: number;

  /**
   * @generated from field: optional int32 unassigned_job_count = 2 [json_name = "unassigned_job_count"];
   */
  unassigned_job_count?: number;

  /**
   * @generated from field: optional int32 active_route_count = 3 [json_name = "active_route_count"];
   */
  active_route_count?: number;
};

/**
 * Describes the message raccoonai.ServiceProviderStats.
 * Use `create(ServiceProviderStatsSchema)` to create a new message.
 */
export const ServiceProviderStatsSchema: GenMessage<ServiceProviderStats, {jsonType: ServiceProviderStatsJson}> = /*@__PURE__*/
  messageDesc(file_analytics, 0);

